import { ToastHelper } from "../../assets/js/helpers/toast";
import { Translation } from "../../assets/js/helpers/translation";

export class SearchBox {

  cssClassName = "c-searchbox1";
  inputContainerSelector = `.${this.cssClassName}__input-container`;
  inputSelector = `.${this.cssClassName}__input`;
  placeHolderSelector = `.${this.cssClassName}__ph`;
  hiddenClassPH = "--hidden";
  showClassPH = "--show";

  constructor(el = null) {
    this.el = el;
    this.init();
  }
  
  init() {
    this.el.querySelectorAll( this.inputContainerSelector ).forEach( element => {
      var input = element.querySelector(this.inputSelector);
      if( input.tagName.toLowerCase() == "select" ){
        input.onchange = (e) => {
          if( e.target.selectedIndex > 0 ){
            element.querySelector(this.placeHolderSelector).classList.remove(this.showClassPH);
            element.querySelector(this.placeHolderSelector).classList.add(this.hiddenClassPH);
          }else{
            element.querySelector(this.placeHolderSelector).classList.remove(this.hiddenClassPH);
            element.querySelector(this.placeHolderSelector).classList.add(this.showClassPH);
          }
        };
      }
    });
  } 

}
